<div
  *ngIf="isOpen"
  class="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4"
>
  <!-- Main Modal Container with dark slate borders -->
  <div
    class="relative overflow-hidden rounded-3xl w-full max-w-[calc(100%-2rem)] sm:max-w-sm p-6 text-center shadow-2xl transition-all duration-300"
    style="background: #080c10; border: 1px solid #233247;"
  >
    <!-- Premium Gold Top Reflection Line -->
    <div 
      class="absolute top-0 left-0 w-full h-[1.5px]" 
      style="background: linear-gradient(90deg, transparent 15%, rgba(244, 194, 59, 0.3) 35%, #f4c23b 50%, rgba(244, 194, 59, 0.3) 65%, transparent 85%); z-index: 10;"
    ></div>

    <div class="flex justify-center mb-5">
      <!-- Profile Image with matching dark slate-blue border instead of gold -->
      <img
        [src]="profileImage"
        alt="Profile"
        class="w-20 h-20 rounded-[20px] object-cover shadow-lg"
        style="border: 2px solid #233247;"
      />
    </div>

    <h2
      class="text-xl mb-6 font-semibold tracking-wide"
      style="
        color: #e2e8f0;
        font-family: 'Plus Jakarta Sans', sans-serif;
      "
    >
      Are you sure you want to Logout?
    </h2>

    <div class="flex gap-3 justify-center items-center">
      <button
        (click)="onCancel.emit()"
        class="px-6 py-2 rounded-xl transition-all font-medium text-xs tracking-wider uppercase flex-1"
        style="
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(148, 163, 184, 0.3);
          color: #94a3b8;
          cursor: pointer;
        "
        onmouseover="
          this.style.background = 'rgba(255,255,255,0.08)';
          this.style.color = '#e2e8f0';
        "
        onmouseout="
          this.style.background = 'rgba(255,255,255,0.03)';
          this.style.color = '#94a3b8';
        "
      >
        Cancel
      </button>

      <button
        (click)="onConfirm.emit()"
        class="logout-btn px-6 py-2 rounded-xl transition-all font-bold text-xs tracking-wider uppercase flex-1"
        style="
          background: #e7b53f;
          border: none;
          color: #0a0f1d;
          cursor: pointer;
        "
        onmouseover="
          this.style.background = '#f5cf6b';
          this.style.transform = 'scale(1.02)';
        "
        onmouseout="
          this.style.background = '#e7b53f';
          this.style.transform = 'scale(1)';
        "
      >
        Logout
      </button>
    </div>
  </div>
</div>